import React from 'react';
import Icon from '../../../components/AppIcon';

const SkillsPreview = () => {
  const skillCategories = [
    {
      title: "Frontend",
      icon: "Monitor",
      color: "text-blue-600",
      bgColor: "bg-blue-50",
      skills: [
        { name: "React", icon: "Code", level: 95 },
        { name: "TypeScript", icon: "FileCode", level: 90 },
        { name: "Tailwind CSS", icon: "Palette", level: 92 },
        { name: "Next.js", icon: "Zap", level: 88 }
      ]
    },
    {
      title: "Backend",
      icon: "Server",
      color: "text-green-600",
      bgColor: "bg-green-50",
      skills: [
        { name: "Node.js", icon: "Terminal", level: 93 },
        { name: "Python", icon: "Code2", level: 87 },
        { name: "PostgreSQL", icon: "Database", level: 85 },
        { name: "MongoDB", icon: "HardDrive", level: 82 }
      ]
    },
    {
      title: "Tools & DevOps",
      icon: "Settings",
      color: "text-purple-600",
      bgColor: "bg-purple-50",
      skills: [
        { name: "Docker", icon: "Package", level: 88 },
        { name: "AWS", icon: "Cloud", level: 85 },
        { name: "Git", icon: "GitBranch", level: 95 },
        { name: "CI/CD", icon: "Workflow", level: 80 }
      ]
    }
  ];

  return (
    <section className="py-20 bg-surface">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Technical Expertise
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Proficient in modern technologies and frameworks to build scalable, performant applications
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {skillCategories?.map((category, index) => (
            <div 
              key={category?.title}
              className="bg-card rounded-xl p-6 shadow-subtle hover:shadow-moderate transition-all duration-300 group"
            >
              <div className="flex items-center mb-6">
                <div className={`w-12 h-12 ${category?.bgColor} rounded-lg flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300`}>
                  <Icon name={category?.icon} size={24} className={category?.color} />
                </div>
                <h3 className="text-xl font-semibold text-foreground">{category?.title}</h3>
              </div>

              <div className="space-y-4">
                {category?.skills?.map((skill) => (
                  <div key={skill?.name} className="space-y-2">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-2">
                        <Icon name={skill?.icon} size={16} className="text-muted-foreground" />
                        <span className="text-sm font-medium text-foreground">{skill?.name}</span>
                      </div>
                      <span className="text-xs text-muted-foreground">{skill?.level}%</span>
                    </div>
                    <div className="w-full bg-muted rounded-full h-2">
                      <div 
                        className={`h-2 rounded-full transition-all duration-1000 ease-out ${
                          category?.title === 'Frontend' ? 'bg-blue-600' :
                          category?.title === 'Backend' ? 'bg-green-600' : 'bg-purple-600'
                        }`}
                        style={{ width: `${skill?.level}%` }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Quick Stats */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-3">
              <Icon name="Code" size={24} className="text-primary" />
            </div>
            <div className="text-2xl font-bold text-foreground">15+</div>
            <div className="text-sm text-muted-foreground">Technologies</div>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-3">
              <Icon name="Zap" size={24} className="text-accent" />
            </div>
            <div className="text-2xl font-bold text-foreground">99%</div>
            <div className="text-sm text-muted-foreground">Performance</div>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 bg-green-500/10 rounded-full flex items-center justify-center mx-auto mb-3">
              <Icon name="CheckCircle" size={24} className="text-green-600" />
            </div>
            <div className="text-2xl font-bold text-foreground">100%</div>
            <div className="text-sm text-muted-foreground">Quality</div>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 bg-orange-500/10 rounded-full flex items-center justify-center mx-auto mb-3">
              <Icon name="Clock" size={24} className="text-orange-600" />
            </div>
            <div className="text-2xl font-bold text-foreground">24/7</div>
            <div className="text-sm text-muted-foreground">Support</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SkillsPreview;